import BaseParagraph from "../baseComponents/baseParagraph";
import {  useDispatch } from "react-redux";
import { actions as loginActions } from "../store/slices/loginSlice.js";
import { useNavigate } from "react-router-dom";
import useColors from "../customHooks/useColors";

const Logout = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [currentColors] = useColors();

  //redux states

  //handling methods
  const handleLogout = () => {
    navigate("/");
    dispatch(loginActions.logout());
  };
  return (
    <BaseParagraph
      style={{
        ...props.style,
        color: currentColors.primary,
        cursor: "pointer",
      }}
      onClick={handleLogout}
    >
      logout
    </BaseParagraph>
  );
};

export default Logout;
